import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 36 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 25\" id=\"icon-check\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.68 8.958l8.14 8.9L33.138 0l3.343 3.99-25.032 20.97L0 12.924z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol